// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b5e526b9","453":"f6123fb6","455":"07adc843"}[chunkId] + ".chunk.js";
};